import { matchesTaskStatusFilter, type TaskStatusFilter } from './taskWorkflow';

export type TaskListVisibilityRecord = Parameters<typeof matchesTaskStatusFilter>[0];

export function hasActiveTaskSearchQuery(searchQuery: string) {
  return String(searchQuery || '').trim().length > 0;
}

export function filterVisibleTasks<T extends TaskListVisibilityRecord>(
  tasks: T[],
  {
    showCompletedTasks,
    statusFilter,
    searchQuery,
  }: {
    showCompletedTasks: boolean;
    statusFilter: TaskStatusFilter;
    searchQuery: string;
  }
) {
  const includeCompletedMatches = hasActiveTaskSearchQuery(searchQuery);

  return tasks
    .filter((task) => includeCompletedMatches || showCompletedTasks || !matchesTaskStatusFilter(task, 'completed'))
    .filter((task) => matchesTaskStatusFilter(task, statusFilter));
}
